// extracted by mini-css-extract-plugin
export default {"container":"Map_container__UaVJS","map":"Map_map__jRLez","heading":"Map_heading__z-5SW","navBtn":"Map_navBtn__kB3ld"};